let ContactData = {
  Email_Address: "Email Address",
  Phone_No: "Mobile No",
  First_Name: "First Name",
  Last_Name: "Last Name",
  Marital_Status: "Marital Status",
  Gender: "Gender",
  City: "City",
  State: "State",
};

export const courseJson = {
  CourseName: "",
  Country: "",
  University: "",
};

export const GenderData = [
  {
    1: "Male",
  },
  {
    2: "Female",
  },
  {
    4: "Other",
    Priorityy: 3,
  },
];

let ContactData_Nepal = {
  Email_Address: "Email Address",
  Phone_No: "Mobile No",
  First_Name: "First Name",
  Last_Name: "Last Name",
};

export const ContactCreateValidator1 = (data) => {
  for (let key in ContactData) {
    const Value = data[key].toString().trim();
    if (Value === "" || Value === undefined || Value === null) {
      return `Error - ${ContactData[key]} is required !`;
    }
  }

  return "success";
};

export const GET_DATE = (time) => {
  var today = new Date(time);
  const yyyy = today.getFullYear();
  let mm = today.getMonth() + 1; // Months start at 0!
  let dd = today.getDate();

  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;

  const formattedToday = yyyy + "-" + mm + "-" + dd;
  return formattedToday;
};

export const ContactCreateValidator1_Nepal = (data) => {
  for (let key in ContactData_Nepal) {
    const Value = data[key].toString().trim();
    if (Value === "" || Value === undefined || Value === null) {
      return `Error - ${ContactData_Nepal[key]} is required !`;
    } else if (
      key === "Email_Address" &&
      (!Value.includes(".") || !Value.includes("@"))
    ) {
      return "Error - please provide a valid email address !";
    }
  }

  return "success";
};


